(function () {
    'use strict';

    angular.module("imApp").factory("metaTableViewsService", ['$ihttp', function ($ihttp) {
        let service = {
            listMetaTableViews: function (parms) {
                return $ihttp.post({
                    method: 2428,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
